/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

class DwmEmails {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.emailIsValid = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};
            if (assets.primaryMember) {

                $scope.primaryEmail = assets.primaryMember.primaryEmail;
                $scope.emails = assets.primaryMember.monitoredAccounts.emails;
                let index = 1;
                $scope.emails.entries.forEach((entry) => {

                    index += 1;
                    entry.index = index;
                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('#email').focus();

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.emailIsValid = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newEmail = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.emails.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    const newEntry = { ...entry };
                    $scope.updateEntryPayload = newEntry;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-email').focus();

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.emailIsValid = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.emails.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

        };

        $scope.validateEmail = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.emailIsValid = validations.emailValidator($event.currentTarget.value);

            }

            $scope.newEmail = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.emailIsValid = validations.emailValidator($scope.newEmail);

            $scope.newEntrySubmitted = true;

            if ($scope.emailIsValid) {

                $scope.saveNewEmailIsLoading = true;

                const payload = {
                    emails: {
                        emailAddress: $scope.newEmail,
                        type: 'OTHER',
                    },
                };
                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newEmail = '';
                    $scope.saveNewEmailIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);
                        $scope.cancelNewEntry();

                        const { monitoredAccounts, dwmCardStatus } =
                            membersResponse.data.primaryMember;

                        Mixpanel.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Email',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                    });

                }).catch((responseError) => {

                    $scope.saveNewEmailIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });

            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                emails:
                {
                    id: $scope.emails.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newEmail = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Email',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.entryUpdateValue = ($event) => {

            $scope.emailIsValid = validations.emailValidator($event.currentTarget.value);

            if ($scope.emailIsValid) {

                $scope.updateEntryPayload.emailAddress = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: { emails: $scope.updateEntryPayload },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Email',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

            });

        };

    }

}

_serviceDependencies.push(DwmEmails);

angular.module('controllers')
    .controller('DwmEmails', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/emails/emails.js